import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_pdf = _resolveComponent("pdf")!
  const _component_DocumentPDF = _resolveComponent("DocumentPDF")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "8",
          class: "pr-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "default_card_wm elevation-0 pt-2",
              style: {"height":"90vh"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        (_ctx.mode !== 'GeneralLedger' && _ctx.goBackHistory)
                          ? (_openBlock(), _createBlock(_component_v_btn_back, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"])),
                              "data-cy": "document-back"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "8",
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_slider, {
                          modelValue: _ctx.pagesPerRow,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagesPerRow) = $event)),
                          label: "Pages par ligne",
                          max: 4,
                          min: 1,
                          step: "1",
                          "hide-details": "",
                          "tick-size": "4",
                          "show-ticks": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_menu, { "offset-y": "" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, { class: "mx-1" }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              nav: "",
                              rounded: "xl"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.enableAnalysis)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      onClick: _ctx.analyseDocument
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                                            _createTextVNode("$oss-scan")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                                            _createTextVNode("Lancer l'analyse")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.document.signedUrl)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      onClick: _ctx.startDownloadFile
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                                            _createTextVNode("$oss-download")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                                            _createTextVNode("Télécharger le document")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_list_item, {
                                  disabled: _ctx.disabledDelete,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteDocumentDialog = true)),
                                  color: "error",
                                  active: !_ctx.disabledDelete
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createTextVNode("$oss-trash")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode("Supprimer")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "active"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center",
                      onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onZoneIn())),
                      onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onZoneOut()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: _normalizeClass(["d-flex", _ctx.loading ? 'justify-center' : 'd-flex justify-start']),
                          style: {"max-height":"83vh","overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                      key: 0,
                                      size: 50,
                                      indeterminate: ""
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (_ctx.src)
                              ? _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_pdf, {
                                      source: _ctx.src,
                                      onLoaded: _ctx.loaded
                                    }, null, 8, ["source", "onLoaded"])
                                  ]),
                                  _: 1
                                }, 512)), [
                                  [_vShow, false]
                                ])
                              : _createCommentVNode("", true),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.pages,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pages) = $event)),
                              tag: "div",
                              class: _normalizeClass(["py-1 no-gutters draggable-main d-flex", _ctx.loading ? 'justify-center' : 'justify-start']),
                              onStart: _ctx.onDragStart,
                              onEnd: _ctx.onDragEnd
                            }, {
                              item: _withCtx(({ element, index }) => [
                                (_openBlock(), _createBlock(_component_v_col, {
                                  cols: _ctx.pdfCol,
                                  key: index,
                                  onClick: ($event: any) => (_ctx.split(index)),
                                  onMouseover: ($event: any) => (_ctx.onPageOver(element, index)),
                                  onMouseout: ($event: any) => (_ctx.onMouseLeave(element)),
                                  class: "draggable-col"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: "draggable-col-div",
                                      style: _normalizeStyle(_ctx.getBorder(index, element.hover))
                                    }, [
                                      (element.display)
                                        ? (_openBlock(), _createBlock(_component_DocumentPDF, {
                                            key: 0,
                                            ref: 'pdf' + index,
                                            id: index + '',
                                            srcImport: _ctx.src,
                                            page: element.index,
                                            rotate: element.direction,
                                            resize: true,
                                            scrollWheelZoomAvailable: false,
                                            style: {"width":"100%"},
                                            class: _normalizeClass(
                                                        element.remove
                                                            ? 'hover'
                                                            : _ctx.isInside(index)
                                                              ? ''
                                                              : 'hover'
                                                    )
                                          }, {
                                            loading: _withCtx(() => _cache[26] || (_cache[26] = [
                                              _createTextVNode(" Chargement en cours ")
                                            ])),
                                            _: 2
                                          }, 1032, ["id", "srcImport", "page", "rotate", "class"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_overlay, {
                                        modelValue: element.hover,
                                        "onUpdate:modelValue": ($event: any) => ((element.hover) = $event),
                                        opacity: "0",
                                        class: "align-center justify-center",
                                        contained: "",
                                        absolute: true
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_trash, {
                                            size: "x-small",
                                            class: "my-0 mr-1",
                                            onClick: _withModifiers(($event: any) => (_ctx.removePage(index)), ["stop"])
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_v_btn, {
                                            size: "x-small",
                                            class: "my-0 mr-1",
                                            onClick: _withModifiers(($event: any) => (
                                                            _ctx.rotatePage('left', element, index)
                                                        ), ["stop"]),
                                            icon: "$fa-undo"
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_v_btn, {
                                            size: "x-small",
                                            class: "my-0",
                                            onClick: _withModifiers(($event: any) => (
                                                            _ctx.rotatePage('right', element, index)
                                                        ), ["stop"]),
                                            icon: "$fa-redo"
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_v_btn, {
                                            size: "x-small",
                                            class: "my-0",
                                            icon: "$oss-zoom-in",
                                            onClick: _withModifiers(($event: any) => (_ctx.openZoomDialog(index)), ["stop"])
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                      (
                                                        index < _ctx.pageCount &&
                                                        (_ctx.isEndPage(index) || element.hover)
                                                    )
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            variant: 
                                                        !_ctx.isEndPage(index) && element.hover
                                                            ? 'outlined'
                                                            : 'flat'
                                                    ,
                                            size: "x-small",
                                            class: "split",
                                            icon: "$fa-cut"
                                          }, null, 8, ["variant"]))
                                        : _createCommentVNode("", true)
                                    ], 4)
                                  ]),
                                  _: 2
                                }, 1032, ["cols", "onClick", "onMouseover", "onMouseout"]))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class", "onStart", "onEnd"])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "4",
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","overflow":"hidden"},
              class: "default_card_wm fill-height elevation-0 rounded-l-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      "single-line": "",
                      class: "pt-0",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          ripple: false,
                          class: "oss-list-item mb-2",
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createElementVNode("b", null, "Statut", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "9",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.documentStatus || "inconnu") + " ", 1),
                                        _createVNode(_component_v_spacer),
                                        (
                                                    _ctx.activateReconciliation &&
                                                    _ctx.reconciliationCallToAction &&
                                                    _ctx.mode !== 'Reconciliation'
                                                )
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              elevation: "0",
                                              disabled: _ctx.disabledCallToAction,
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openReconciliation())),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.reconciliationCallToAction), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list, { style: {"height":"72vh","overflow":"auto"} }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageRanges, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            class: "py-0 px-0",
                            onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onZoneIn())),
                            onMouseout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onZoneOut()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                onMouseover: ($event: any) => (_ctx.onMouseOver(item)),
                                onMouseleave: ($event: any) => (_ctx.onMouseLeave(item)),
                                class: "pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "pl-2",
                                    cols: "5"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            class: "font-weight-bold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Document " + _toDisplayString(index + 1), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            class: "pt-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" De la page " + _toDisplayString(item.start + 1) + " à " + _toDisplayString(item.end + 1), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "pl-2",
                                    cols: "5"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: item.type,
                                        "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                        items: _ctx.documentTypes,
                                        outlined: "",
                                        "hide-details": "",
                                        density: "compact",
                                        "item-title": "text"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "d-flex align-center justify-center"
                                  }, {
                                    default: _withCtx(() => [
                                      (index < _ctx.pageRanges.length - 1)
                                        ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.split(item.end)),
                                            size: "small"
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "pt-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onMouseover", "onMouseleave"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_warning, _mergeProps({
                                      size: "x-small",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setOpenChat('DENIED'))),
                                      class: "mr-1",
                                      disabled: _ctx.inDocument.status === 'DENIED'
                                    }, props), null, 16, ["disabled"])
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "Rejeter", -1))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 1,
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_icon, _mergeProps({
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setOpenChat('INFORMATION_REQUEST'))),
                                      class: "mx-1",
                                      size: "x-small"
                                    }, props, { icon: "$oss-chat" }), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "Question", -1))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_btn, {
                              class: "mx-1",
                              loading: _ctx.splitLoading,
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialog = true)),
                              disabled: _ctx.inDocument.status === 'DENIED',
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("Découper")
                              ])),
                              _: 1
                            }, 8, ["loading", "disabled"]),
                            (_ctx.mode != 'GeneralLedger' && _ctx.mode !== 'Reconciliation')
                              ? (_openBlock(), _createBlock(_component_v_btn_prev, {
                                  key: 2,
                                  disabled: _ctx.previousDisabled(),
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.previous()))
                                }, null, 8, ["disabled"]))
                              : _createCommentVNode("", true),
                            (_ctx.mode != 'GeneralLedger' && _ctx.mode !== 'Reconciliation')
                              ? (_openBlock(), _createBlock(_component_v_btn_next, {
                                  key: 3,
                                  disabled: _ctx.nextDisabled(),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.next()))
                                }, null, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 0,
          id: _ctx.inDocument.chat ? _ctx.inDocument.chat.id : '',
          inShowMessage: _ctx.open_chat,
          chatTitle: 'Document',
          chatSubtitle: _ctx.getChatSubTitle(),
          showSmartChat: _ctx.wishStatus !== 'DENIED',
          onMessageSent: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onMessageSent($event))),
          onShowMessageChanged: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onShowMessageChanged($event)))
        }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dialog) = $event)),
      title: "Découper le document",
      validLoading: _ctx.splitLoading,
      onValid: _cache[17] || (_cache[17] = ($event: any) => (_ctx.splitDocument())),
      width: "50vw"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.inDocument.status === "VALIDATED"
                    ? "Attention : les documents générés précédement seront supprimés."
                    : "Validez pour générer le(s) document(s)."), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[31] || (_cache[31] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.pdfDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.pdfDialog) = $event)),
      title: "Document PDF",
      validLoading: _ctx.splitLoading,
      width: "50vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DocumentPDF, {
          srcImport: _ctx.src,
          page: _ctx.pageViewed,
          rotate: _ctx.rotate,
          scrollWheelZoomAvailable: true
        }, null, 8, ["srcImport", "page", "rotate"])
      ]),
      _: 1
    }, 8, ["modelValue", "validLoading"])
  ]))
}